import {of as observableOf, combineLatest as observableCombineLatest, Observable} from 'rxjs';

import {map, takeWhile} from 'rxjs/operators';
import {ChangeDetectionStrategy, ChangeDetectorRef, Component} from '@angular/core';
import {ValuesObject} from '../detail-tabconfig';
import {ResourceService} from '../../resource.service';
import {Router} from '@angular/router';
import {ViewTabComponent} from '../viewtab.component';
import {AbstractControlReadonlyComponent} from './abstract-control-readonly';
import {ErrorService} from '../../../error/error.service';

@Component({
  selector: 'ctrl-hyperlink',
  template: `
    <p>
      @if (objectReference != null) {
        <a (click)="onClick()">{{ captionObs | async }}</a>
      }
      @if (objectReference == null && navigateUrl != null) {
        <a [href]="navigateUrl" target="_blank">{{ captionObs | async }}</a>
      }
    </p>
  `,
  styles: ['p { margin: 0; padding: 3px 0 7px; line-height: 1; min-height: 24px; }'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CtrlHyperLinkComponent extends AbstractControlReadonlyComponent {
  constructor(
    private router: Router,
    parent: ViewTabComponent,
    changeDetector: ChangeDetectorRef,
    errorService: ErrorService,
  ) {
    super(parent, null, changeDetector, errorService);
  }

  objectReference: string = null;
  navigateUrl: string = '';
  captionObs: Observable<string> = null;

  protected initSource(): void {}

  protected initMain(): void {
    if (this._config.propertyExists('ObjectReference')) {
      this.getCaughtObservable(this._config.getPropertyValues('ObjectReference'))
        .pipe(takeWhile(() => this.alive))
        .subscribe(reference => {
          if (ResourceService.guidRegex.test(reference)) {
            this.objectReference = reference;
          } else {
            this.objectReference = null;
          }
          this.changeDetector.markForCheck();
        });
    }

    if (this._config.propertyExists('NavigateUrl')) {
      this.getCaughtObservable(this._config.getPropertyValues('NavigateUrl'))
        .pipe(takeWhile(() => this.alive))
        .subscribe(val => {
          this.navigateUrl = val;
          this.changeDetector.markForCheck();
        });
    }

    if (this._config.Caption != null && this._config.propertyExists('Text')) {
      this.captionObs = this.getCaughtObservable(
        observableCombineLatest(
          this._config.Caption,
          this._config.getPropertyValues('Text'),
          (caption: ValuesObject<string>, text: string) => {
            if (text != null && text.length > 0) {
              return text;
            } else {
              return caption;
            }
          },
        ),
      );
    } else if (this._config.propertyExists('Text')) {
      this.captionObs = this.getCaughtObservable(this._config.getPropertyValues('Text'));
    } else if (this._config.Caption != null) {
      this.captionObs = this.getCaughtObservable(
        this._config.Caption.pipe(map(vo => (vo ? vo.Values : null))),
      );
    } else {
      this.captionObs = observableOf('Open Link');
    }
    this.changeDetector.markForCheck();
  }

  onClick() {
    if (this.objectReference != null) {
      this.router.navigate(['/get', this.objectReference]);
    } else if (this.navigateUrl != null) {
      window.location.href = this.navigateUrl;
    }
  }
}
